import React from 'react';
import {
    Col, Row, Modal,
    Form, FormGroup, FormControl, ControlLabel
} from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';
import decode from 'jwt-decode';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import { API_ROOT } from '../../variables/api-config';
import MaskedFormControl from 'react-bootstrap-maskedinput'
import ContactService from '../../services/ContactService';

class ModalCargaFactura extends React.Component {
  constructor(props) {
    super(props);
    let labelTipo;
    if (this.props.currentFactura) {
      switch (this.props.currentFactura.tipo) {
        case '001':
          labelTipo = 'A';
          break;
        case '006':
          labelTipo = 'B';
          break;
        case '011':
          labelTipo = 'C';
          break;
        default:

      }
    }
    this.state = {
      currentUser: decode(localStorage.getItem('id_token')),
      fecha: this.props.currentFactura ? this.props.currentFactura.fecha : '',
      numero: this.props.currentFactura ? this.props.currentFactura.numero : '',
      tipo: this.props.currentFactura ? {value: this.props.currentFactura.tipo, label: labelTipo} : '',
      proveedor: this.props.currentFactura ? {value: this.props.currentFactura.proveedor, label: this.props.currentFactura.proveedor} : '',
      cuit: this.props.currentFactura ? this.props.currentFactura.cuit : '',
      concepto: this.props.currentFactura ? this.props.currentFactura.concepto : '',
      neto: this.props.currentFactura ? this.props.currentFactura.neto : '',
      retencioniibb: this.props.currentFactura && this.props.currentFactura.subtipo === 'COMPRA' ? this.props.currentFactura.ingresosbrutos : 0,
      archivo: null,
      alicuotaiva: this.props.currentFactura ? {value: parseFloat(this.props.currentFactura.alicuotaiva), label: `${parseFloat(this.props.currentFactura.alicuotaiva)*100}%` } : {value: 0.21, label: '21%'},
      iva: this.props.currentFactura ? this.props.currentFactura.iva : '',
      total: this.props.currentFactura ? this.props.currentFactura.total : '',
      nombrearchivo: this.props.currentFactura ? this.props.currentFactura.originalname : null,
      idfactura: this.props.currentFactura ? this.props.currentFactura.id : null,
      condicioniva: this.props.currentFactura ? {value: this.props.currentFactura.condicioniva, label: this.props.currentFactura.condicioniva} : '',
      otrosconceptos: this.props.currentFactura ? this.props.currentFactura.otrosconceptos : 0,
      error: {},
      alicuotaib: this.props.currentFactura ? this.props.currentFactura.alicuotaib : 0,
      contacts: null,
    };
    this.contactService = new ContactService();
    this.onSave = this.onSave.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onChangeTipo = this.onChangeTipo.bind(this);
    this.onChangeNeto = this.onChangeNeto.bind(this);
    this.onChangeTotal = this.onChangeTotal.bind(this);
    this.onChangeAlicuotaIva = this.onChangeAlicuotaIva.bind(this);
    this.onChangeIibb = this.onChangeIibb.bind(this);
    this.onChangeOtros = this.onChangeOtros.bind(this);
    this.clearError = this.clearError.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
  }

  componentWillMount() {
    this.contactService.getContactsNameAndCuit()
    .then(res => {
      const contacts = res.contacts.map((item, index) => {
        return {value: index, label: `${item.apellido} ${item.nombre}`, cuit: item.cuit};
      });
      this.setState({ contacts });
    })
    .catch(err => {
      this.props.setError(
        <div>
          Ha ocurrido un error mientras se cargaba la información, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>
      );
    });
  }

  clearError(key) {
    const auxError = this.state.error;
    auxError[key] = false;
    this.setState({error: auxError});
  }

  checkErrors(factura, array) {
    const auxError = this.state.error;
    let error = false;
    Object.keys(factura).forEach((key) => {
      if (key !== 'otrosconceptos' && key !== 'ingresosbrutos' && key !== 'idfactura' && key !== 'rendida' && key !== 'alicuotaib' &&
      (!factura[key] || factura[key] === '')) {
        if (!array.includes(key)) {
          auxError[key] = true;
          error = true;
        }
      }
    });
    this.setState({error: auxError});
    return error;
  }
  onSave() {
    const retencioniibb = this.state.retencioniibb && this.state.retencioniibb === '' ? 0 : this.state.retencioniibb;
    const condicioniva = this.state.condicioniva ? this.state.condicioniva.label : '';
    const tipo = this.state.tipo ? this.state.tipo.value : '';
    let estado = this.props.tipo === 'VENTAS' ? 'SOLICITADA' : null;
    if (this.props.uncusa) {
      estado = 'APROBADA';
    }
    const alicuotaiva = this.state.alicuotaiva ? this.state.alicuotaiva.value : '';
    const proveedor = this.state.proveedor ? this.state.proveedor.value : '';
    const factura = {
      fecha: this.state.fecha,
      tipo,
      numero: this.state.numero,
      proveedor,
      cuit: this.state.cuit,
      concepto: this.state.concepto,
      neto: this.state.neto,
      ingresosbrutos: retencioniibb,
      archivo: this.state.archivo,
      rendida: false,
      alicuotaiva,
      iva: this.state.iva,
      total: this.state.total,
      estado,
      subtipo: this.props.tipo,
      idfactura: this.state.idfactura,
      otrosconceptos: this.state.otrosconceptos,
      condicioniva,
      alicuotaib: this.state.alicuotaib,
    };

    let arrayCheck = [];
    if (this.props.tipo === 'VENTAS') {
      arrayCheck = ['numero', 'archivo'];
    } else {
      arrayCheck = ['condicioniva', 'estado'];
    }
    if (this.props.uncusa) {
      arrayCheck = [];
    }

    const error = this.checkErrors(factura, arrayCheck);

    if (!error) {
      this.props.save(factura);
    } else {
      this.props.setError(
        <div>
          Uno o más campos contienen errores o no fueron completados!
        </div>
      );
    }
  }

  handleFileChange(e) {
    e.preventDefault();
    this.setState({ archivo: this.uploadInput.files[0], nombrearchivo: this.uploadInput.files[0].name });
    this.clearError('archivo')
  }

  onChangeAlicuotaIva(value) {
    if (value) {
      if (this.state.tipo && this.state.tipo !== '') {
        if (this.state.tipo.label === 'A') {
          this.setState({alicuotaiva: value});
          this.onChangeNeto(this.state.neto, value.value);
        } else {
          this.setState({alicuotaiva: value});
          this.onChangeTotal(this.state.total, value.value);
        }
      } else {
        this.setState({alicuotaiva: value});
      }
    } else {
      this.setState({
        alicuotaiva: value,
        iva: '',
        total: '',
        neto: '',
      });
    }
    this.clearError('alicuotaiva');
  }

  onChangeTipo(value) {
    this.setState({
      tipo: value,
      iva: '',
      total: '',
      neto: '',
    });
    this.clearError('tipo');
  }

  onChangeNeto(value, alicuota) {
    if (value !== '') {
      const numberValue = parseFloat(value, 10);
      let iva = numberValue * alicuota;
      iva =+ iva.toFixed(2);
      this.setState({
        neto: numberValue,
        iva,
        total: (numberValue + iva),
        retencioniibb: this.props.tipo === 'COMPRA' ? '' : null,
        alicuotaib: this.props.tipo === 'VENTAS' ? '' : null,
        otrosconceptos: '',
      });
    } else {
      this.setState({
        neto: value,
        iva: '',
        total: '',
        retencioniibb: this.props.tipo === 'COMPRA' ? '' : null,
        alicuotaib: this.props.tipo === 'VENTAS' ? '' : null,
        otrosconceptos: '',
      });
    }
    this.clearError('neto');
    this.clearError('iva');
    this.clearError('total');
    this.clearError('ingresosbrutos');
    this.clearError('otrosconceptos');
  }

  onChangeIibb(value) {
    this.setState({ retencioniibb: value });
    this.clearError('ingresosbrutos');
    this.onChangeTotal(parseFloat(this.state.neto) + parseFloat(this.state.iva), this.state.alicuotaiva.value, value, this.state.otrosconceptos);
  }

  onChangeAlicuotaIb(value) {
    let resultado = parseFloat(value)/100*(parseFloat(this.state.neto) + parseFloat(this.state.iva));
    resultado =+ resultado.toFixed(2);
    this.setState({ alicuotaib: value, retencioniibb: resultado });
    this.onChangeTotal(parseFloat(this.state.neto) + parseFloat(this.state.iva), this.state.alicuotaiva.value, resultado, this.state.otrosconceptos);
  }

  onChangeOtros(value) {
    this.setState({ otrosconceptos: value });
    this.clearError('otrosconceptos');
    this.onChangeTotal(parseFloat(this.state.neto) + parseFloat(this.state.iva), this.state.alicuotaiva.value, this.state.retencioniibb, value);
  }

  onChangeTotal(value, alicuota, iibb, otros) {
    if (iibb || otros) {
      let extra;
      if (!iibb || iibb === '') {
        extra = parseFloat(otros) + 0;
      } else if (!otros || otros === '') {
        extra = parseFloat(iibb) + 0;
      } else {
        extra = parseFloat(iibb) + parseFloat(otros);
      }
      this.setState({
        total: parseFloat(value) + parseFloat(extra),
      });
      this.clearError('total');
    } else {
      if (value !== '') {
        const numberValue = parseFloat(value, 10);
        let neto = numberValue / (1 + alicuota);
        neto =+ neto.toFixed(2);
        this.setState({
          retencioniibb: this.props.tipo === 'COMPRA' ? '' : null,
          alicuotaib: this.props.tipo === 'VENTAS' ? '' : null,
          otrosconceptos: '',
          neto,
          iva: (numberValue - neto).toFixed(2),
          total: numberValue,
        });
        this.clearError('total');
        this.clearError('iva');
        this.clearError('neto');
        this.clearError('otrosconceptos');
        this.clearError('ingresosbrutos');
      } else {
        this.setState({
          neto: '',
          iva: '',
          total: value,
        });
        this.clearError('total');
        this.clearError('neto');
        this.clearError('iva');
      }
    }
  }

  handleChange = (newValue) => {
    if (!newValue) {
      this.setState({ proveedor: {value: '', label: ''} });
    } else {
      this.setState({ proveedor: {value: newValue.label, label: newValue.label}});
      this.clearError('proveedor');
      if (newValue.cuit && newValue.cuit !== '') {
        this.setState({ cuit: newValue.cuit });
        this.clearError('cuit');
      };
    }
  };

  render() {
    let tiposList;
    if (this.props.tipo === 'COMPRA') {
      tiposList = [
        {value: '001', label: 'A'},
        {value: '011', label: 'C'},
      ];
    } else if (this.props.tipo === 'VENTAS') {
      tiposList = [
        {value: '001', label: 'A'},
        {value: '006', label: 'B'},
      ];
    }
    const ivaList = [
      {value: 0, label: '0%'},
      {value: 0.025, label: '2.5%'},
      {value: 0.05, label: '5%'},
      {value: 0.105, label: '10.5%'},
      {value: 0.21, label: '21%'},
      {value: 0.27, label: '27%'},
    ];
    const condicionesList = [
      {value: 'RI', label: 'Responsable Inscripto'},
      {value: 'Mono', label: 'Responsable Monotributista'},
      {value: 'Exento', label: 'Responsable Exento'},
      {value: 'CF', label: 'Consumidor Final'},
      {value: 'Otro', label: 'Otro'},
    ]
    const renderNumero = this.props.tipo !== 'VENTAS' || this.props.uncusa;
    return (
      <div>
        <Modal.Body>
          <div>
            <Form horizontal>
              <Row>
                {renderNumero &&
                  <div>
                    <Col md={12}>
                      <FormGroup  validationState={this.state.error.numero ? 'error': null}>
                        <Col componentClass={ControlLabel} md={2} style={{textAlign:'left', paddingTop: '7px'}}>
                          Nº Factura:
                        </Col>
                        <Col md={4}>
                          <MaskedFormControl type='text'  mask='1111-111111111111'  value={this.state.numero}
                            onChange={(e) => this.setState({ numero: e.target.value }, this.clearError('numero'))}
                            disabled={this.props.readOnly}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </div>
                }
                <Col md={6}>
                  <FormGroup validationState={this.state.error.tipo ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      Tipo:
                    </Col>
                    <Col md={8}>
                      <Select
                        style={{ borderColor: this.state.error.tipo ? "#e40040" : "#aaa"}}
                        placeholder=""
                        closeOnSelect={true}
                        name="type"
                        value={this.state.tipo}
                        options={tiposList}
                        onChange={(value) => { this.onChangeTipo(value) }}
                        disabled={this.props.readOnly}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.fecha ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      Fecha:
                    </Col>
                    <Col md={8}>
                      <FormControl
                        type="date" value={this.state.fecha} onChange={(e) => this.setState({fecha: e.target.value}, this.clearError('fecha'))}
                        disabled={this.props.readOnly}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.proveedor ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      {this.props.tipo === 'VENTAS' ? 'Cliente:' : 'Proveedor:'}
                    </Col>
                    <Col md={8}>
                      <CreatableSelect
                        style={{ borderColor: this.state.error.proveedor ? "#e40040" : "#aaa"}}
                        isClearable
                        closeOnSelect
                        promptTextCreator={(label) => { return 'Agregar opción "' + label + '"'}}
                        onChange={this.handleChange}
                        options={this.state.contacts}
                        value={this.state.proveedor}
                        disabled={this.props.readOnly}
                        placeholder={'Seleccione o ingrese texto'}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={this.props.tipo === 'VENTAS' ? 3 : 6}>
                  <FormGroup validationState={this.state.error.cuit ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      CUIT:
                    </Col>
                    <Col md={8}>
                      <FormControl
                        type="text" value={this.state.cuit} onChange={(e) => this.setState({ cuit: e.target.value }, this.clearError('cuit'))}
                        disabled={this.props.readOnly}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                {this.props.tipo === 'VENTAS' &&
                  <Col md={3}>
                    <FormGroup validationState={this.state.error.condicioniva ? 'error': null}>
                      <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                        Condición:
                      </Col>
                      <Col md={8}>
                        <Select
                          style={{ borderColor: this.state.error.condicioniva ? "#e40040" : "#aaa"}}
                          placeholder="Seleccione"
                          closeOnSelect={true}
                          name="type"
                          value={this.state.condicioniva}
                          options={condicionesList}
                          onChange={(value) => { this.setState({condicioniva: value}, this.clearError('condicioniva')) }}
                          disabled={this.props.readOnly}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                }
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.concepto ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      Concepto:
                    </Col>
                    <Col md={8}>
                      <FormControl
                        type="text" value={this.state.concepto} onChange={(e) => this.setState({ concepto: e.target.value }, this.clearError('concepto'))}
                        disabled={this.props.readOnly}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.neto ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      Importe Neto:
                    </Col>
                    <Col md={8}>
                      <FormControl
                        type="number" value={this.state.neto} onChange={(e) => this.onChangeNeto(e.target.value, this.state.alicuotaiva.value)}
                        step="0.01" disabled={!this.state.tipo || this.state.tipo === '' || this.state.tipo.label !== 'A' || this.props.readOnly}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.alicuotaiva ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      IVA:
                    </Col>
                    <Col md={8}>
                      <Select
                        style={{ borderColor: this.state.error.alicuotaiva ? "#e40040" : "#aaa"}}
                        placeholder="Seleccione"
                        closeOnSelect={true}
                        name="type"
                        value={this.state.alicuotaiva}
                        options={ivaList}
                        onChange={(value) => { this.onChangeAlicuotaIva(value)}}
                        disabled={this.props.readOnly}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.iva ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      Total IVA:
                    </Col>
                    <Col md={8}>
                      <FormControl
                        type="text" value={this.state.iva} disabled
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.total ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      Total Bruto:
                    </Col>
                    <Col md={8}>
                      <FormControl
                        type="number" value={this.state.total} onChange={(e) => this.onChangeTotal(e.target.value, this.state.alicuotaiva.value)}
                        step="0.01" disabled={!this.state.tipo || this.state.tipo === '' || this.state.tipo.label === 'A' || this.props.readOnly}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup validationState={this.state.error.otrosconceptos ? 'error': null}>
                    <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                      Otros Conceptos:
                    </Col>
                    <Col md={8}>
                      <FormControl
                        type="number" value={this.state.otrosconceptos} onChange={(e) => this.onChangeOtros(e.target.value)}
                        disabled={!this.state.total || this.state.total === '' || this.props.readOnly} step="0.01"
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                {this.props.tipo === 'VENTAS' ?
                  <Col md={6}>
                    <FormGroup validationState={this.state.error.alicuotaib ? 'error': null}>
                      <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                        % Ingresos Brutos:
                      </Col>
                      <Col md={8}>
                        <FormControl
                          type="number" value={this.state.alicuotaib} onChange={(e) => this.onChangeAlicuotaIb(e.target.value)}
                          disabled={this.props.readOnly} min={0} max={100}
                        />
                      </Col>
                    </FormGroup>
                  </Col> :
                  <Col md={6}>
                    <FormGroup validationState={this.state.error.ingresosbrutos ? 'error': null}>
                      <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                        Percepción IIBB:
                      </Col>
                      <Col md={8}>
                        <FormControl
                          type="number" value={this.state.retencioniibb} onChange={(e) => this.onChangeIibb(e.target.value)}
                          disabled={!this.state.total || this.state.total === '' || this.props.readOnly} step="0.01"
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                }
                {(this.props.tipo === "COMPRA" || this.props.uncusa) &&
                  <Col md={6}>
                    <FormGroup validationState={this.state.error.archivo ? 'error': null}>
                      <Col componentClass={ControlLabel} md={4} style={{textAlign:'left', paddingTop: '7px'}}>
                        Archivo:
                      </Col>
                      <Col md={8}>
                        {(this.props.readOnly && this.state.nombrearchivo) ?
                          <FormControl.Static>
                            <a href={`${API_ROOT}/incubation/factura/download/file?id=${this.state.idfactura}`}>
                              Descargar Archivo
                              {'      '}
                              <i className="fa fa-download"></i>
                            </a>
                          </FormControl.Static> :
                          <FormControl
                            type="text" value={this.state.nombrearchivo ? this.state.nombrearchivo : 'No se seleccionó ningún archivo..'}
                            disabled
                          />
                        }
                      </Col>
                    </FormGroup>
                  </Col>
                }
              </Row>
              {(this.props.tipo === "COMPRA" || this.props.uncusa) && !this.props.readOnly &&
                <Row>
                  <Col md={6}>
                    <span style={{ float: 'left' }}>
                      <input ref={(ref) => { this.uploadInput = ref; }} type="file" style={{'visibility': 'hidden'}} onChange={this.handleFileChange} />
                    </span>
                  </Col>
                  <Col md={6}>
                    <span style={{ float: 'right' }}>
                      <Button onClick={() => this.uploadInput.click()} bsStyle="primary" fill={true}>Seleccionar archivo</Button>
                      <Button disabled={!this.state.archivo && !this.state.nombrearchivo} onClick={() => this.setState({ archivo: null, nombrearchivo: null })} bsStyle="danger" fill={true}>
                        <i className="fa fa-ban"></i>
                      </Button>
                    </span>
                  </Col>
                </Row>
              }
            </Form>
          </div>
        </Modal.Body>
        {!this.props.readOnly &&
          <Modal.Footer>
            <Button simple onClick={this.props.cancel}>
              Cancelar
            </Button>
            <Button
              bsStyle="success" fill onClick={this.onSave}
              >
                {this.props.uncusa ? 'Aprobar' : 'Guardar'}
              </Button>
            </Modal.Footer>
        }
      </div>
    );
  }
}

export default ModalCargaFactura;



// WEBPACK FOOTER //
// ./src/views/Components/ModalCargaFactura.jsx